// This is just an example,
// so you can safely delete all default props below

export default {
    travel_from: 'From',
    travel_to: 'To',
    stop_place_holder: 'Enter or select a stop/quay',
    outward_date: 'Depart',
    backward_date: 'Return',
    oneway: 'One way',
    roundtrip: 'Round trip',
    search_trips: 'Search and book',
    error_products_not_found: 'There are no connections between the places you selected, or on the date you selected, or there are no more departures today for the selected trip.',
    error_origin: 'From must be selected',
    error_destination: 'To must be selected',
    error_outward_date: 'Outward date must be selected',
    error_backward_date: 'Backward date must be selected',
    error_products: 'No ticket category is selected',
    payment_option_desc: 'Choice of payment- / reservation product is selected on the page 3'
}
